import registerExtension from './register-extension';
import updateExtension from './update-extension';
import addToRegistry from './add-to-registry';

export default {
  registerExtension,
  addToRegistry,
  updateExtension,
};
